module.exports = __webpack_public_path__ + "static/media/Sleep.6ff7eb74.jpg";